// Lightweight ad-platform analytics. Scripts load only when IDs are configured via env.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const ADS_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

const addScript = (src) => { const s = document.createElement('script'); s.async = true; s.src = src; document.head.appendChild(s); };

export const initAnalytics = () => {
  if (typeof window === 'undefined' || window.__ggAnalyticsInit) return;
  window.__ggAnalyticsInit = true;
  window.dataLayer = window.dataLayer || [];
  if (GA_ID || ADS_ID) {
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    if (GA_ID) window.gtag('config', GA_ID);
    if (ADS_ID) window.gtag('config', ADS_ID);
    addScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID || ADS_ID}`);
  }
  if (PIXEL_ID && !window.fbq) {
    const n = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    window.fbq = n; window._fbq = n;
    addScript('https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }
};

// Fires the "quote request completed" conversion across configured platforms.
export const trackQuoteConversion = ({ submissionId, service }) => {
  if (typeof window === 'undefined') return;
  const params = { event: 'quote_request_submitted', transaction_id: submissionId, service_needed: service || 'unspecified' };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(params);
  if (window.gtag) {
    window.gtag('event', 'generate_lead', { transaction_id: submissionId, service_needed: params.service_needed, currency: 'USD', value: 0 });
    if (ADS_ID && ADS_LABEL) window.gtag('event', 'conversion', { send_to: `${ADS_ID}/${ADS_LABEL}`, transaction_id: submissionId });
  }
  if (window.fbq) window.fbq('track', 'Lead', { content_name: params.service_needed }, { eventID: submissionId });
};
